module.exports = __webpack_public_path__ + "img/quickLoginBG.09a40a40.jpg";